import { Component } from '@angular/core';
import { AuthService } from '@auth0/auth0-angular';
import { BrowserStorageHelper } from '@core/helpers';
import { environment } from '@environments/environment';
import { AppRoutesEnum } from '@shared/enums';
import { ButtonModule } from 'primeng/button';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-unauthorized-page',
    templateUrl: './unauthorized-page.component.html',
    styleUrls: ['./unauthorized-page.component.scss'],
    standalone: true,
    imports: [ButtonModule, TranslateModule],
})
export class UnauthorizedPageComponent {
    urls = AppRoutesEnum;

    constructor(private auth0: AuthService) {}

    openChat(): void {
        // @ts-ignore
        window['happyFoxChat'].showWidget();
        // @ts-ignore
        window['happyFoxChat'].expandChatbox();
    }

    async logout(): Promise<void> {
        const url = `${environment.auth0.logoutUrl}?client_id=${environment.auth0.clientId}&returnTo=${encodeURI(
            environment.auth0.logoutReturnUrl
        )}`;
        BrowserStorageHelper.killSession();

        await this.auth0.logout({
            openUrl(_url) {
                window.location.replace(url);
            },
        });
    }
}
